import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const MANUAL_SEARCH_REDUCER_NAME = "manual-search";

const initialState = {
  filters: [],
  searchId: null,
  ruleId: null,
  columns: [],
  enabled: false,
};

const manualSearchSlice = createSlice({
  name: MANUAL_SEARCH_REDUCER_NAME,
  initialState,
  reducers: {
    setManualSearchParams: (state, { payload }) => {
      state.filters = payload.filters;
      state.searchId = payload.searchId;
      state.ruleId = payload.ruleId;
      state.columns = payload.columns;
      state.enabled = true;
    },
    clearManualSearch: () => ({ ...initialState }),
  },
});

export default manualSearchSlice.reducer;

export const { setManualSearchParams, clearManualSearch } =
  manualSearchSlice.actions;

export const useSelectManualSearchEnabled = () =>
  useSelector((state) => state[MANUAL_SEARCH_REDUCER_NAME].enabled);

export const useSelectManualSearchFilters = () =>
  useSelector((state) => state[MANUAL_SEARCH_REDUCER_NAME].filters);

export const useSelectManualSearchSearchId = () =>
  useSelector((state) => state[MANUAL_SEARCH_REDUCER_NAME].searchId);

export const useSelectManualSearchRuleId = () =>
  useSelector((state) => state[MANUAL_SEARCH_REDUCER_NAME].ruleId);

export const useSelectManualSearchColumns = () =>
  useSelector((state) => state[MANUAL_SEARCH_REDUCER_NAME].columns);
